export const subscriptionsStrings = /** @type {const} */ ({
  english: {
    startDate: 'Start Date',
    nextRenewal: 'Next Renewal',
    status: 'Status',
    total: 'Total',
    type: 'Type',
    actions: 'Actions',
    view: 'View',
  },
});

export const subscriptionDetailsStrings = /** @type {const} */ ({
  english: {
    title: 'SUBSCRIPTION DETAILS',
    placed: 'was placed on',
    currency: 'and is currently',
    manage: 'You can manage your keys from My Account',
    pay: 'PAYMENT METHOD:',
    TOTAL: 'TOTAL:',
    info: 'BILLING INFORMATION',
    subscription: 'Subscription',
    cancelTitle: 'SUBSCRIPTION OPTIONS',
    cancel: 'Cancel',
    pause: 'Pause',
    resume: 'Resume',
  },
});
